// extracted by css-extract-rspack-plugin
export default {"cls1":"AttachmentOverlay-cls1_AN4","cls2":"AttachmentOverlay-cls2_Y6Y AttachmentOverlay-cls1_AN4"};